<template>
  <div>
    <h2>Saved Plans</h2>
    <table>
      <thead>
      <tr>
        <th>Plan Name</th>
        <th>Price (£/month)</th>
        <th>Covers Existing Guarantee</th>
        <th colspan="2">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="plan in plans">
        <td>
          {{ plan.plan_name }}
        </td>
        <td>
          £{{ parseFloat(plan.monthly_cost).toFixed(2) }}
        </td>
        <td>
          <span v-if="plan.guarantee_type == 0">Yes</span>
          <span v-if="plan.guarantee_type == 1">No</span>
          <span v-if="plan.guarantee_type == 2">Not sure</span>
        </td>
        <td>
          <span @click="edit(plan)" class="edit-button">Edit</span>
        </td>
        <td>
          <span @click="destroy(plan)" class="delete-button">Delete</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Plans",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data(){
    return{
      plans: null,
    }
  },
  mounted(){
    this.getPlans();
  },
  methods: {
    getPlans(){
      this.plans = [];
      this.$axios.post(`${this.base}/api/plans/get.php`)
      .then((response) => {
        this.plans = response.data;
      });
    },
    edit(plan){
      this.$emit('edit', plan);
    },
    destroy(plan){
      if (confirm(`Are you sure you want to delete ${plan.plan_name}?`)){
        this.$axios.post(`${this.base}/api/plans/delete.php`, this.$makeForm({ plan_slug: plan.plan_slug }))
            .then(() => {
              this.getPlans();
            })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
table{
  width: 50%;
  border-collapse: collapse;
  border: {
    left: 1px solid #CCD0D4;
    right: 1px solid #CCD0D4;
    bottom: 1px solid #CCD0D4;
  }
  thead{
    th{
      border: {
        top: 1px solid #CCD0D4;
        bottom: 1px solid #CCD0D4;
      }
      font-weight: normal;
      color: #32373C;
      background-color: #FFF;
      padding: 0.5rem;
      text-align: left;
    }
  }
  td{
    padding: 0.5rem;
  }

  tr:nth-child(odd) {
    background-color: #F9F9F9;
  }

  tr:nth-child(even) {
    background-color: #FFF;
  }

}

.edit-button{
  cursor: pointer;
  &:hover{
    color: orange;
  }
}

.delete-button{
  cursor: pointer;
  &:hover{
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Plans.vue